module.exports = __webpack_public_path__ + "static/media/img-tag-moduleB1.93569b89.png";